

<body class="mat-app-background">
  <div class="container-fluid mat-elevation-z8" style="height: calc(100vh - 185px);">
    <div class="row d-flex" style="height: 100%;">
      <div class="col-md-9 columna1 p-0 m-0 resizable-column" #columna1 id="columna1"
        (mousedown)="startResizing2($event, columna1)">
        <app-grafica-rendimiento [selectedTab]="selectedTab" [modelo]="modelo" [isGestion]="isGestion"
          [isBroker]="isBroker" [isPlanificador]="isPlanificador">
        </app-grafica-rendimiento>
      </div>

      <div class="col-md-3 p-0 columna2" #columna2 id="columna2">

        <!-- ── RENDIMIENTOS ── -->
        <div class="rr-block" *ngIf="modelo">
          <div class="rr-section-header">RENDIMIENTOS</div>
          <div class="rr-scroll">
            <table cdk-table [dataSource]="rentabilidad" class="table-striped tableStyle">
              <ng-container cdkColumnDef="nombre">
                <th cdk-header-cell *cdkHeaderCellDef></th>
                <td cdk-cell *cdkCellDef="let element" style="width:70%">{{element.nombre}}</td>
              </ng-container>
              <ng-container cdkColumnDef="dato">
                <th cdk-header-cell *cdkHeaderCellDef></th>
                <td cdk-cell *cdkCellDef="let element" style="width:30%" [ngClass]="{'numero-positivo': element.dato > 0, 'numero-negativo': element.dato < 0}">{{element.dato}}</td>
              </ng-container>
              <tr cdk-header-row *cdkHeaderRowDef="displayedColumns" hidden></tr>
              <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
        </div>

        <div class="rr-block" *ngIf="isPlanificador">
          <div class="rr-section-header">RENDIMIENTOS</div>
          <div class="rr-scroll">
            <table cdk-table [dataSource]="divRendimiento" class="table-striped tableStyle">
              <ng-container cdkColumnDef="nombre">
                <th cdk-header-cell *cdkHeaderCellDef></th>
                <td cdk-cell *cdkCellDef="let element" style="width:70%">{{element.nombre}}</td>
              </ng-container>
              <ng-container cdkColumnDef="dato">
                <th cdk-header-cell *cdkHeaderCellDef></th>
                <td cdk-cell *cdkCellDef="let element" style="width:30%" [ngClass]="{'numero-positivo': element.dato > 0, 'numero-negativo': element.dato < 0}">{{element.dato}}</td>
              </ng-container>
              <tr cdk-header-row *cdkHeaderRowDef="displayedColumns" hidden></tr>
              <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
        </div>

        <div class="rr-block" *ngIf="isGestion">
          <div class="rr-section-header">RENDIMIENTOS</div>
          <div class="rr-scroll">
            <table cdk-table [dataSource]="gestRentabilidad" class="table-striped tableStyle">
              <ng-container cdkColumnDef="nombre">
                <th cdk-header-cell *cdkHeaderCellDef></th>
                <td cdk-cell *cdkCellDef="let element" style="width:70%">{{element.nombre}}</td>
              </ng-container>
              <ng-container cdkColumnDef="dato">
                <th cdk-header-cell *cdkHeaderCellDef></th>
                <td cdk-cell *cdkCellDef="let element" style="width:30%" [ngClass]="{'numero-positivo': element.dato > 0, 'numero-negativo': element.dato < 0}">{{element.dato}}</td>
              </ng-container>
              <tr cdk-header-row *cdkHeaderRowDef="displayedColumns" hidden></tr>
              <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
        </div>

        <div class="rr-block" *ngIf="isBroker">
          <div class="rr-section-header">RENDIMIENTOS</div>
          <div class="rr-scroll">
            <table cdk-table [dataSource]="brokRentabilidad" class="table-striped tableStyle">
              <ng-container cdkColumnDef="nombre">
                <th cdk-header-cell *cdkHeaderCellDef></th>
                <td cdk-cell *cdkCellDef="let element" style="width:70%">{{element.nombre}}</td>
              </ng-container>
              <ng-container cdkColumnDef="dato">
                <th cdk-header-cell *cdkHeaderCellDef></th>
                <td cdk-cell *cdkCellDef="let element" style="width:30%" [ngClass]="{'numero-positivo': element.dato > 0, 'numero-negativo': element.dato < 0}">{{element.dato}}</td>
              </ng-container>
              <tr cdk-header-row *cdkHeaderRowDef="displayedColumns" hidden></tr>
              <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
        </div>

        <!-- ── RIESGO ── -->
        <div class="rr-block" *ngIf="modelo">
          <div class="rr-section-header">RIESGO</div>
          <div class="rr-scroll">
            <table cdk-table [dataSource]="riesgo" class="table-striped tableStyle">
              <ng-container cdkColumnDef="nombre">
                <th cdk-header-cell *cdkHeaderCellDef></th>
                <td cdk-cell *cdkCellDef="let element" style="width:70%">{{element.nombre}}</td>
              </ng-container>
              <ng-container cdkColumnDef="dato">
                <th cdk-header-cell *cdkHeaderCellDef></th>
                <td cdk-cell *cdkCellDef="let element" style="width:30%" [ngClass]="{'numero-positivo': element.dato > 0, 'numero-negativo': element.dato < 0}">{{element.dato}}</td>
              </ng-container>
              <tr cdk-header-row *cdkHeaderRowDef="displayedColumns" hidden></tr>
              <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
        </div>

        <div class="rr-block" *ngIf="isPlanificador">
          <div class="rr-section-header">RIESGO</div>
          <div class="rr-scroll">
            <table cdk-table [dataSource]="divRiesgo" class="table-striped tableStyle">
              <ng-container cdkColumnDef="nombre">
                <th cdk-header-cell *cdkHeaderCellDef></th>
                <td cdk-cell *cdkCellDef="let element" style="width:70%">{{element.nombre}}</td>
              </ng-container>
              <ng-container cdkColumnDef="dato">
                <th cdk-header-cell *cdkHeaderCellDef></th>
                <td cdk-cell *cdkCellDef="let element" style="width:30%" [ngClass]="{'numero-positivo': element.dato > 0, 'numero-negativo': element.dato < 0}">{{element.dato}}</td>
              </ng-container>
              <tr cdk-header-row *cdkHeaderRowDef="displayedColumns" hidden></tr>
              <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
        </div>

        <div class="rr-block" *ngIf="isGestion">
          <div class="rr-section-header">RIESGO</div>
          <div class="rr-scroll">
            <table cdk-table [dataSource]="gestRiesgo" class="table-striped tableStyle">
              <ng-container cdkColumnDef="nombre">
                <th cdk-header-cell *cdkHeaderCellDef></th>
                <td cdk-cell *cdkCellDef="let element" style="width:70%">{{element.nombre}}</td>
              </ng-container>
              <ng-container cdkColumnDef="dato">
                <th cdk-header-cell *cdkHeaderCellDef></th>
                <td cdk-cell *cdkCellDef="let element" style="width:30%" [ngClass]="{'numero-positivo': element.dato > 0, 'numero-negativo': element.dato < 0}">{{element.dato}}</td>
              </ng-container>
              <tr cdk-header-row *cdkHeaderRowDef="displayedColumns" hidden></tr>
              <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
        </div>

        <div class="rr-block" *ngIf="isBroker">
          <div class="rr-section-header">RIESGO</div>
          <div class="rr-scroll">
            <table cdk-table [dataSource]="brokRiesgo" class="table-striped tableStyle">
              <ng-container cdkColumnDef="nombre">
                <th cdk-header-cell *cdkHeaderCellDef></th>
                <td cdk-cell *cdkCellDef="let element" style="width:70%">{{element.nombre}}</td>
              </ng-container>
              <ng-container cdkColumnDef="dato">
                <th cdk-header-cell *cdkHeaderCellDef></th>
                <td cdk-cell *cdkCellDef="let element" style="width:30%" [ngClass]="{'numero-positivo': element.dato > 0, 'numero-negativo': element.dato < 0}">{{element.dato}}</td>
              </ng-container>
              <tr cdk-header-row *cdkHeaderRowDef="displayedColumns" hidden></tr>
              <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
        </div>

        <!-- ── RENDIMIENTO ANUAL ── -->
        <div class="rr-block rr-block--grow" *ngIf="modelo">
          <div class="rr-section-header">RENDIMIENTO ANUAL</div>
          <cdk-virtual-scroll-viewport #viewportRednAnual id="viewportRednAnual" [appendOnly]="false" [tvsItemSize]="24"
            [headerHeight]="34" class="wrapper mat-elevation-z2 tableStyle">
            <table cdk-table [dataSource]="rendAnual" class="table-striped tableStyle">
              <tr cdk-header-row *cdkHeaderRowDef="displayedColumnsRend; sticky: true" class="sticky-header"></tr>
              <tr cdk-row *cdkRowDef="let row; columns: displayedColumnsRend;"></tr>
              <ng-container *ngFor="let tablecol of tableColumnsRend">
                <ng-container [cdkColumnDef]="tablecol.id">
                  <th cdk-header-cell *cdkHeaderCellDef class="sticky-header sortable-header" (click)="sortRendAnual(tablecol.id)">
                    {{tablecol.name}}
                    <span *ngIf="sortColumnRend === tablecol.id" class="sort-arrow">{{sortDirectionRend === 'asc' ? '↑' : '↓'}}</span>
                  </th>
                  <td cdk-cell *cdkCellDef="let item" [ngClass]="{'numero-positivo': item[tablecol.id] > 0, 'numero-negativo': item[tablecol.id] < 0}">
                    <ng-container *ngIf="tablecol.isString">{{item[tablecol.id]}}</ng-container>
                    <ng-container *ngIf="tablecol.isNumber">{{item[tablecol.id] | number:'1.2-2'}}</ng-container>
                  </td>
                </ng-container>
              </ng-container>
            </table>
          </cdk-virtual-scroll-viewport>
        </div>

        <div class="rr-block rr-block--grow" *ngIf="isPlanificador">
          <div class="rr-section-header">RENDIMIENTO ANUAL</div>
          <cdk-virtual-scroll-viewport #viewportRednAnual id="viewportRednAnual" [appendOnly]="false" [tvsItemSize]="24"
            [headerHeight]="34" class="wrapper mat-elevation-z2 tableStyle">
            <table cdk-table [dataSource]="divRendAnual" class="table-striped tableStyle">
              <tr cdk-header-row *cdkHeaderRowDef="displayedColumnsRend; sticky: true" class="sticky-header"></tr>
              <tr cdk-row *cdkRowDef="let row; columns: displayedColumnsRend;"></tr>
              <ng-container *ngFor="let tablecol of tableColumnsRend">
                <ng-container [cdkColumnDef]="tablecol.id">
                  <th cdk-header-cell *cdkHeaderCellDef class="sticky-header sortable-header" (click)="sortRendAnual(tablecol.id)">
                    {{tablecol.name}}
                    <span *ngIf="sortColumnRend === tablecol.id" class="sort-arrow">{{sortDirectionRend === 'asc' ? '↑' : '↓'}}</span>
                  </th>
                  <td cdk-cell *cdkCellDef="let item" [ngClass]="{'numero-positivo': item[tablecol.id] > 0, 'numero-negativo': item[tablecol.id] < 0}">
                    <ng-container *ngIf="tablecol.isString">{{item[tablecol.id]}}</ng-container>
                    <ng-container *ngIf="tablecol.isNumber">{{item[tablecol.id] | number:'1.2-2'}}</ng-container>
                  </td>
                </ng-container>
              </ng-container>
            </table>
          </cdk-virtual-scroll-viewport>
        </div>

        <div class="rr-block rr-block--grow" *ngIf="isGestion">
          <div class="rr-section-header">RENDIMIENTO ANUAL</div>
          <cdk-virtual-scroll-viewport #viewportRednAnual id="viewportRednAnual" [appendOnly]="false" [tvsItemSize]="24"
            [headerHeight]="34" class="wrapper mat-elevation-z2 tableStyle">
            <table cdk-table [dataSource]="gestRendAnual" class="table-striped tableStyle">
              <tr cdk-header-row *cdkHeaderRowDef="displayedColumnsRend; sticky: true" class="sticky-header"></tr>
              <tr cdk-row *cdkRowDef="let row; columns: displayedColumnsRend;"></tr>
              <ng-container *ngFor="let tablecol of tableColumnsRend">
                <ng-container [cdkColumnDef]="tablecol.id">
                  <th cdk-header-cell *cdkHeaderCellDef class="sticky-header sortable-header" (click)="sortRendAnual(tablecol.id)">
                    {{tablecol.name}}
                    <span *ngIf="sortColumnRend === tablecol.id" class="sort-arrow">{{sortDirectionRend === 'asc' ? '↑' : '↓'}}</span>
                  </th>
                  <td cdk-cell *cdkCellDef="let item" [ngClass]="{'numero-positivo': item[tablecol.id] > 0, 'numero-negativo': item[tablecol.id] < 0}">
                    <ng-container *ngIf="tablecol.isString">{{item[tablecol.id]}}</ng-container>
                    <ng-container *ngIf="tablecol.isNumber">{{item[tablecol.id] | number:'1.2-2'}}</ng-container>
                  </td>
                </ng-container>
              </ng-container>
            </table>
          </cdk-virtual-scroll-viewport>
        </div>

        <div class="rr-block rr-block--grow" *ngIf="isBroker">
          <div class="rr-section-header">RENDIMIENTO ANUAL</div>
          <cdk-virtual-scroll-viewport #viewportRednAnual id="viewportRednAnual" [appendOnly]="false" [tvsItemSize]="24"
            [headerHeight]="34" class="wrapper mat-elevation-z2 tableStyle">
            <table cdk-table [dataSource]="brokRendAnual" class="table-striped tableStyle">
              <tr cdk-header-row *cdkHeaderRowDef="displayedColumnsRend; sticky: true" class="sticky-header"></tr>
              <tr cdk-row *cdkRowDef="let row; columns: displayedColumnsRend;"></tr>
              <ng-container *ngFor="let tablecol of tableColumnsRend">
                <ng-container [cdkColumnDef]="tablecol.id">
                  <th cdk-header-cell *cdkHeaderCellDef class="sticky-header sortable-header" (click)="sortRendAnual(tablecol.id)">
                    {{tablecol.name}}
                    <span *ngIf="sortColumnRend === tablecol.id" class="sort-arrow">{{sortDirectionRend === 'asc' ? '↑' : '↓'}}</span>
                  </th>
                  <td cdk-cell *cdkCellDef="let item" [ngClass]="{'numero-positivo': item[tablecol.id] > 0, 'numero-negativo': item[tablecol.id] < 0}">
                    <ng-container *ngIf="tablecol.isString">{{item[tablecol.id]}}</ng-container>
                    <ng-container *ngIf="tablecol.isNumber">{{item[tablecol.id] | number:'1.2-2'}}</ng-container>
                  </td>
                </ng-container>
              </ng-container>
            </table>
          </cdk-virtual-scroll-viewport>
        </div>

      </div>
    </div>
  </div>

  <div class="spinner-container" *ngIf="loading">
    <mat-spinner diameter="100"></mat-spinner>
  </div>
</body>
